module.exports = __webpack_public_path__ + "static/media/twt.b3268505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-img/twt.png
// module id = 9421
// module chunks = 0